module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e53NaN"
    }
  }), _c('p', {
    staticClass: "serh"
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "9781937084646_txt_0001_001",
      "id": "d14e43",
      "src": "images/9781937084646_txt_0001_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e111"
    }
  }, [_c('b', [_vm._v("WRITTEN AND WITH PHOTOGRAPHS ")]), _c('br'), _c('b', [_vm._v("BY GRETTA PARKER ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0534656b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Park_9781937084721_epub_c1_r1.vue
// module id = 57
// module chunks = 0